import styles from "./AccountInfoCard.module.scss";

interface AccountInfoCardProps {
  title: string;
  type: string;
  icon: string;
  value: string;
  changeType: string;
  onClick?: () => void;
}

const AccountInfoCard: React.FC<AccountInfoCardProps> = ({ title, icon, type, value, changeType, onClick }) => {
  return (
    <div className={styles.root}>
      <img src={icon} alt="icon" className={styles.root_icon} />
      <div className={styles.root_info}>
        <p className={styles.root_title}>{title}</p>
        <div className={styles.root_info_values}>
          <p className={styles.root_info_type}> {type}:</p>
          <p className={styles.root_info_value}>{value}</p>
          <p className={styles.root_info_changeType} onClick={onClick}>
            {changeType}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccountInfoCard;
